import { LayoutDefault, LayoutDefaultProps } from '@graphcommerce/next-ui'
import { useB2BLoginWall } from '../../lib/hooks/useB2BLoginWall'
import { B2BLoginWall } from '../B2BLoginWall/B2BLoginWall'
import { Footer } from './Footer'
import { LayoutQuery } from './Layout.gql'
import { Logo } from './Logo'

export type LayoutMinimalProps = LayoutQuery &
  Omit<LayoutDefaultProps, 'header' | 'footer' | 'cartFab' | 'noSticky'> & {
    up?: {
      href?: string
    }
  }

export function LayoutMinimal(props: LayoutMinimalProps) {
  const { footer, footerLinkList1, menu, children, up, ...uiProps } = props
  const shrinkLogo = up && up.href !== '/cart' && up.href !== '/checkout'
  const sx = shrinkLogo ? {} : { transform: `scale(0.65)`, transformOrigin: `50% 0` }
  const { enableLoginWall } = useB2BLoginWall()

  return (
    <>
      {!enableLoginWall && (
        <LayoutDefault
          {...uiProps}
          header={<Logo sx={{ ...sx }} />}
          footer={<Footer footer={footer} />}
          sx={{ background: (theme) => theme.palette.background.paper }}
        >
          {children}
        </LayoutDefault>
      )}
      {enableLoginWall && <B2BLoginWall />}
    </>
  )
}
